import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import config from '../utils/config';
import { DocumentUnavailable } from '../components/common';

const RawFileViewer = () => {
    const { type, id } = useParams();
    const [status, setStatus] = useState('loading');
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        const url = `${config.backEndUrl}documents/${type}/${id}/rawfile`;
        fetch(url, { credentials: 'include' })
            .then(res => {
                if (!res.ok) {
                    setStatus('error');
                    return;
                }
                return res.blob().then(blob => {
                    setBlobUrl(URL.createObjectURL(blob));
                    setStatus('ok');
                });
            })
            .catch(() => setStatus('error'));

        return () => {
            if (blobUrl) URL.revokeObjectURL(blobUrl);
        };
    }, [type, id]);

    if (status === 'loading') {
        return (
            <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </div>
        );
    }

    if (status === 'error') {
        return <DocumentUnavailable />;
    }

    return (
        <div style={{ width: '100%', height: '100vh', border: 'none' }}>
            <iframe
                src={blobUrl}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="Document Viewer"
            />
        </div>
    )
}

export default RawFileViewer;